function createApp(App, rootElement = document.body) {
  let isLoaded = document.readyState === "complete";
  let app;
  if (!isLoaded) {
    document.addEventListener("readystatechange", () => {
      if (document.readyState === "complete") {
        app = new App(rootElement).$mount();
        isLoaded = true;
      }
    });
  } else {
    app = new App(rootElement).$mount();
  }
  const promise = new Promise((resolve) => {
    document.addEventListener("readystatechange", () => {
      if (document.readyState === "complete") {
        setTimeout(() => resolve(app), 0);
      }
    });
  });
  return function useApp() {
    if (isLoaded) {
      return Promise.resolve(app);
    }
    return promise;
  };
}
export {
  createApp as default
};
